module.exports = __webpack_public_path__ + "static/media/thumb_template copy 2.4a182606.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/utils/thumb_template copy 2.png
// module id = 1597
// module chunks = 0